import React, { FunctionComponent } from "react";

const Footer: FunctionComponent<{}> = () => {
  return <footer />;
};

export default Footer;
